import { Subject } from "rxjs";

export interface ResizedEvent {
    newWidth: number;
    newHeight: number;
}

export class PcpResizeObserver {

    private readonly resized = new Subject<ResizedEvent>();
    readonly resized$ = this.resized.asObservable();

    private readonly resizeObserver: ResizeObserver;

    constructor() {
        this.resizeObserver = new ResizeObserver(entries => {
            let event: undefined | ResizedEvent;
            for (const entry of entries) {
                if (entry.contentBoxSize) {
                    // Firefox implements `contentBoxSize` as a single content rect, rather than an array
                    const contentBoxSize: ResizeObserverSize = Array.isArray(entry.contentBoxSize)
                        ? entry.contentBoxSize[0]
                        : entry.contentBoxSize;

                    event = { newWidth: contentBoxSize.inlineSize, newHeight: contentBoxSize.blockSize };
                } else {
                    event = { newWidth: entry.contentRect.width, newHeight: entry.contentRect.height };
                }
            }

            if (event) {
                this.resized.next(event);
            }
        });
    }

    observe(element: Element) {
        this.resizeObserver.observe(element);
    }

    unobserve(element: Element) {
        this.resizeObserver.unobserve(element);
        this.resized.complete();
    }
}
